import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useUser } from '../../utils/userContext';
import axios from 'axios';
import useHandleErrors from '../../utils/user.utils';
import Select from 'react-select';
import useCountryCodes from '../../utils/useCountryCodes';
import moment from 'moment';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import wwImg from '../../assets/globalImgs/WW-360-Logo.png'
import useConfiguration from '../../utils/ConfigurationContext';


const AdvanceSalary = () => {
    const dropdownRef = useRef(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [amount, setAmount] = useState('');
    const [Reason, setReason] = useState('');
    const [description, setDescription] = useState('');
    const [currencySymbol, setCurrencySymbol] = useState('');
    const { user } = useUser();
    const [loading, setLoading] = useState(false);
    const { currencySymbols } = useCountryCodes();
    const [salaries, setSalaries] = useState([]);
    const config = useConfiguration();
    const handleErrors = useHandleErrors();
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);
    const ClearIndicator = () => null;

    // Fetch policies from your API
    const fetchSalaries = async () => {
        setLoading(true);
        if (user && user?.EmployeeId) {
            try {
                const path = `/getAdvanceSalaryRequests?employeeId=${user?.EmployeeId}`;
                const URL = process.env.REACT_APP_BE_URL + path;
                const response = await axios.get(URL, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.status === 200) {
                    setSalaries(response.data);
                }
                else {
                    handleErrors(response);
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 404) {
                        // Handle 404 status code separately
                        setSalaries([]);
                    } else {
                        handleErrors(error.response);
                    }
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchSalaries();
            hasFetchedRef.current = true;
        }
    }, []);


    useEffect(() => {
        const handleShowDropdown = (e) => {
            const dropdown = dropdownRef.current;
            if (dropdown) {
                document.body.appendChild(dropdown);
            }
        };

        const handleHideDropdown = (e) => {
            const dropdown = dropdownRef.current;
            if (dropdown && e.target.contains(dropdown)) {
                e.target.appendChild(dropdown);
            }
        };

        if (isDropdownOpen) {
            const dropdownParent = dropdownRef.current?.parentElement;
            dropdownParent?.addEventListener('shown.bs.dropdown', handleShowDropdown);
            dropdownParent?.addEventListener('hidden.bs.dropdown', handleHideDropdown);

            return () => {
                dropdownParent?.removeEventListener('shown.bs.dropdown', handleShowDropdown);
                dropdownParent?.removeEventListener('hidden.bs.dropdown', handleHideDropdown);
            };
        }
    }, [isDropdownOpen]);

    const handleDropdownToggle = (e, index) => {
        setIsDropdownOpen(!isDropdownOpen);
        setSelectedRequestIndex(index);
    };

    const handleChange = selectedOption => {
        setReason(selectedOption);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        if (!amount) {
            toast.error("Amount is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
         if (!currencySymbol) {
            toast.error("Currency Symbol is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!Reason) {
            toast.error("Reason is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!description) {
            toast.error("Description is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        console.log("user?.ManagerEmail", user?.ManagerEmail)
        const fullAmount = `${currencySymbol?.split('-')[0]} ${amount}`;
        const postData = {
            EmployeeId: user?.EmployeeId,
            EmployeeName: user?.FirstName,
            EmployeeEmail: user?.OfficialEmail,
            RequestedDate: moment(new Date()).format("YYYY-MM-DD"),
            Amount: fullAmount,
            Reason: Reason,
            Description: description,
            Status: "Pending",
            UpdatedBy: user?.FirstName,
            HrEmail: user?.ManagerEmail,
        };

        try {
            const path = "/advanceSalaryRequest";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, postData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                setShowModal(true)
                setAmount("")
                setReason("")
                setDescription("")
                fetchSalaries();
                setCurrencySymbol("")
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleUpdateClear = () => {
        setFormData({
            amount: "",
            description: "",
            currencySymbol: ""
        });
    };
    const handleClear = () => {
        setAmount("")
        setReason("")
        setDescription("")
        setCurrencySymbol("")
    };


    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(salaries);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'salaries');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            link.download = 'salaries.xlsx';

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "salaries List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const handleExport = () => {
        const ws = utils.json_to_sheet(salaries);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'salaries');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'salaries.xlsx');
    };

    const shareData = {
        title: 'salaries List',
        text: 'Check out the salaries list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };
    const [formData, setFormData] = useState({
        amount: '',
        description: '',
        currencySymbol: ''
    });
    const [selectedRequestIndex, setSelectedRequestIndex] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleUpdate = async () => {
        setLoading(true);
        if (selectedRequestIndex !== null) {
            const selectedRequest = salaries[selectedRequestIndex];
            try {
                const path = `/updateAdvanceSalaryRequest`;
                const URL = process.env.REACT_APP_BE_URL + path;
                const response = await axios.put(URL, {
                    ...selectedRequest,
                    amount: formData.amount,
                    description: formData.description
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                if (response.status === 200) {
                    toast.success("Advance Salary Request Updated successfully!", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                    setFormData({ amount: "", description: "" })
                    const updatedSalaries = [...salaries];
                    updatedSalaries[selectedRequestIndex] = response.data;
                    setSalaries(updatedSalaries);
                    fetchSalaries();
                } else {
                    handleErrors(response)
                }
            } catch (error) {
                console.error('Error updating request', error);
                if (error.response) {
                    handleErrors(error.response);
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    const handleCancel = async (index) => {
        setLoading(true);
        try {
            const path = `/updateAdvanceSalaryRequest`;
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.put(URL, {
                ...salaries[index],
                status: 'Cancelled'
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.status === 200) {
                toast.success("Advance Salary Request Cancelled successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                // Update the salaries state with the cancelled request
                const updatedSalaries = [...salaries];
                updatedSalaries[index].status = 'Cancelled';
                setSalaries(updatedSalaries);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            console.error('Error cancelling request', error);
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const options = currencySymbols.map((country) => ({
        value: country.value,
        label: `${country.value} (${country.label})`,
    }));

    const handleSelectChange = (selectedOption) => {
        setFormData((prevData) => ({
            ...prevData,
            currencySymbol: selectedOption ? selectedOption.value : ''
        }));
    };


    const handleDownloadPDF = (record) => {
        const doc = new jsPDF();

        // Define page margins and dimensions
        const marginLeft = 10;
        const marginRight = 10;
        const pageWidth = doc.internal.pageSize.width;

        // Header
        // Add logo on the left side
        const imgData = wwImg; // Replace with your actual logo path or base64 string
        doc.addImage(imgData, 'PNG', marginLeft, 10, 40, 15); // Logo positioned on the left

        // Add timestamp on the right side in small size
        const timestamp = new Date().toLocaleString();
        doc.setFontSize(8);
        doc.text(timestamp, pageWidth - marginRight, 15, { align: 'right' });

        // Add heading
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(37, 183, 64); // Set text color to #25b740 (RGB: 37, 183, 64)
        doc.text("Advance Salary Request Form", pageWidth / 2, 30, { align: 'center' });

        // Reset text color to black for other text
        doc.setTextColor(0, 0, 0);

        // Add employee details
        doc.setFontSize(10);
        doc.setFont("helvetica", "Bold");
        doc.setTextColor(0, 79, 124); // Set text color to #004f7c (RGB: 0, 79, 124)
        const employeeDetailsStartY = 45; // Start Y position for employee details
        doc.text("Employee Details", marginLeft, employeeDetailsStartY);
        doc.setTextColor(0, 0, 0);
        // Employee details
        const employeeDetails = [
            { label: 'Employee Name', value: record.employeeName },
            { label: 'Employee Email', value: record.employeeEmail }
        ];

        // Draw employee details
        employeeDetails.forEach((detail, index) => {
            const y = employeeDetailsStartY + 10 + (index * 10);
            doc.text(`${detail.label}: ${detail.value}`, marginLeft, y);
        });

        // Draw a thin line above the table
        const lineY = employeeDetailsStartY + 10 + (employeeDetails.length * 10) + 5;
        doc.setDrawColor(0, 0, 0);
        // doc.setLineWidth(0.5); // Standard line width
        doc.line(marginLeft, lineY, pageWidth - marginRight, lineY);

        // Add "Details" heading
        const detailsHeadingY = lineY + 10; // Y position for "Details" heading
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 79, 124); // Set text color to #004f7c (RGB: 0, 79, 124)
        doc.text("Advance Salary Request Details", marginLeft, detailsHeadingY);

        // Define table headers
        const headers = ['Field', 'Value'];
        doc.setTextColor(0, 0, 0);
        const rows = [
            { key: 'Employee ID', value: `${record.employeeId}` },
            { key: 'Reason', value: `${record.reason}` },
            { key: 'Requested Date', value: moment(`${record.requestedDate}`).format("DD-MM-YYYY") },
            { key: 'Amount', value: `${record.amount}` },
            { key: 'Status', value: `${record.status}` },
        ];

        // Define table positions and dimensions
        const tableStartY = detailsHeadingY + 20; // Add space below "Details" heading
        const rowHeight = 10;
        const columnWidth = {
            field: 80,
            value: pageWidth - 100 // Adjust as needed to fit the page width
        };

        // Draw table headers (Field and Value)
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.setDrawColor(0, 0, 0);
        // doc.setLineWidth(0.5); // Normal line width

        // Draw header cell borders
        doc.rect(marginLeft, tableStartY - rowHeight, columnWidth.field, rowHeight); // Field header cell border
        doc.rect(marginLeft + columnWidth.field, tableStartY - rowHeight, columnWidth.value, rowHeight); // Value header cell border

        // Add header text
        doc.text(headers[0], marginLeft + 5, tableStartY - rowHeight / 2 + 3); // "Field" header text
        doc.text(headers[1], marginLeft + columnWidth.field + 5, tableStartY - rowHeight / 2 + 3); // "Value" header text

        // Reset font to normal for table data rows
        doc.setFont("helvetica", "normal");

        // // Draw table rows
        // rows.forEach((row, index) => {
        //     const y = tableStartY + (index * rowHeight) + rowHeight / 2; // Adjusted to center the text vertically
        //     doc.text(row.key, marginLeft + 5, y); // Field value
        //     doc.text(row.value, marginLeft + columnWidth.field + 25, y, { align: 'right' }); // Value
        //     // Draw row borders
        //     doc.setDrawColor(0, 0, 0);
        //     doc.rect(marginLeft, y - rowHeight / 2, columnWidth.field, rowHeight); // Row border
        //     doc.rect(marginLeft + columnWidth.field, y - rowHeight / 2, columnWidth.value, rowHeight); // Row border
        // });

        rows.forEach((row, index) => {
            const y = tableStartY + (index * rowHeight) + rowHeight / 2; // Adjusted to center the text vertically
            const padding = 5; // Same margin/padding for both columns
            // Draw text for the fields and values
            doc.text(row.key, marginLeft + padding, y); // Field text with consistent padding
            doc.text(row.value, marginLeft + columnWidth.field + padding, y); // Value text with consistent padding
            // Draw row borders
            doc.setDrawColor(0, 0, 0);
            doc.rect(marginLeft, y - rowHeight / 2, columnWidth.field, rowHeight); // Row border for the Field column
            doc.rect(marginLeft + columnWidth.field, y - rowHeight / 2, columnWidth.value, rowHeight); // Row border for the Value column
        });

        // Add "Approved By" and "Name" text
        const approvedByY = tableStartY + (rows.length * rowHeight) + 20; // Position below the table
        console.log("first", `${record.updatedBy}`)
        const nameText = `${record.updatedBy}`;
        const approvedByText = "Approved By";

        // Add the text aligned to the right side
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        // "Name" text
        doc.text(nameText, pageWidth - marginRight - 50, approvedByY); // Adjust -50 to move it closer or further from the right

        // "Approved By" text below "Name"
        doc.text(approvedByText, pageWidth - marginRight - 50, approvedByY + 10); // 10 units below "Name"

        // Add footer with timestamp and additional data, aligned left and right
        doc.setFontSize(10);
        const footerTimestamp = `Timestamp: ${timestamp}`;
        const footerText = "Generated By WorkWise360";
        doc.text(footerTimestamp, marginLeft, 280); // Left-aligned footer
        doc.text(footerText, pageWidth - marginRight, 280, { align: 'right' }); // Right-aligned footer


        // Save the PDF
        doc.save(`Advance Salary Request_${record.employeeId}.pdf`);
    };

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Advance Salary Request</h3>
                        </div>
                        <div className="col-auto">
                            <a href={"/SubmitTimesheet"} data-extra-toggle="tab" data-target="#timesheet-pan" className="btn btn-primary mt-lg-0 mt-4"><i className="ri-calendar-schedule-fill"></i> Timesheet</a>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="mt-2">Employee ID</label>
                                        </div>
                                        <div className="col">
                                            <input type="text" className="form-control-plaintext" value={user?.EmployeeId} readOnly />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="mt-2">Employee Name</label>
                                        </div>
                                        <div className="col">
                                            <input type="text" className="form-control-plaintext" value={user?.FirstName + " " + user?.LastName} readOnly />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="mt-2">Employee Email</label>
                                        </div>
                                        <div className="col">
                                            <input type="email" className="form-control-plaintext" value={user?.OfficialEmail} readOnly />
                                        </div>
                                    </div>

                                    <hr />
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label for="currencySymbol" className="required">Amount</label>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <Select
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                                name="currencySymbol"
                                                                value={
                                                                    options.find((option) => `${option.value}-${options.indexOf(option)}` === currencySymbol) || null
                                                                }
                                                                onChange={(selectedOption) => {
                                                                    console.log('Selected Option:', selectedOption); // Debug: Log selected option
                                                                    setCurrencySymbol(selectedOption ? selectedOption.value : '');
                                                                }}
                                                                options={options.map((option, index) => ({
                                                                    ...option,
                                                                    value: `${option.value}-${index}`, // Add the index to make the value unique
                                                                }))}
                                                                components={{ ClearIndicator }}
                                                                isClearable
                                                                menuPortalTarget={document.body} // Ensures the dropdown menu is rendered correctly in a modal
                                                                styles={{
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                    control: base => ({ ...base, zIndex: 1 })
                                                                }}
                                                            />
                                                        </div>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="amount"
                                                            value={amount}
                                                            onChange={(e) => setAmount(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="Reason" className="required">Reason</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={Reason}
                                                        onChange={(e) => setReason(e.target.value)}
                                                        required
                                                        placeholder="Enter Reason"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="required">Description</label>
                                                    <textarea className="form-control" rows="3" value={description} onChange={(e) => setDescription(e.target.value)} required></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <hr />
                                    <div className="row">
                                        <div className="col">
                                            <h5 className="title mt-1 mb-0">Summary</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button type="button" title="Email" className="btn btn-light btn-circle ml-2" onClick={() => sendEmail('')}>
                                                <i className="ri-mail-send-fill"></i>
                                            </button>
                                            <button type="button" title="Share" className="btn btn-light btn-circle ml-2" onClick={handleShare}>
                                                <i className="ri-share-fill"></i>
                                            </button>
                                            <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={handleExport}>
                                                <i className="ri-export-fill"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-12" id="employeePayslipList">
                                            <h6 className="title accordion-title" data-toggle="collapse" data-target="#payslipYear2024-2025">
                                                <i className="ri-calendar-2-line"></i> {moment().year()}
                                                <span className="show-payslip-details float-right">
                                                    <div className="row">
                                                        <div className="col border-right"><i className="ri-cash-line"></i> Available Requests</div>
                                                        <div className="col-auto">
                                                            <span className="text-success">
                                                                {salaries.filter(salary => salary.status?.toLowerCase() === 'pending').length}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </span>
                                            </h6>
                                            <div className="collapse show" id="payslipYear2024-2025" data-parent="#employeePayslipList">
                                                <div className="row mt-3">
                                                    <div className="col-md-12">
                                                        {salaries?.length === 0 ? (
                                                            <div class="container">
                                                                <div class="row  justify-content-center align-items-center">
                                                                    <div class="col-auto">
                                                                        <div class="no-data-wrapper">
                                                                            <div class="no-data-found">
                                                                                <i class="ri-file-damage-fill"></i>
                                                                                <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                                                                <p>No Data Found</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="table-responsive leave-information">
                                                                <table className="table grid">
                                                                    <thead className="bg-light">
                                                                        <tr>
                                                                            <th>S.No.</th>
                                                                            <th>Amount </th>
                                                                            <th>Request Date </th>
                                                                            <th>Status</th>
                                                                            {/* <th>Comments</th> */}
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody>
                                                                        {salaries.map((salary, index) => (
                                                                            <tr key={index}>
                                                                                <td className={`status ${salary.status === 'Pending' ? 'bg-pending' : salary.status === 'Approved' ? 'bg-approved' : 'bg-rejected'}`}>{index + 1}</td>
                                                                                <td>{salary.amount}</td>
                                                                                <td>{moment(salary.requestedDate).format("DD-MM-YYYY")}</td>
                                                                                <td>
                                                                                    <span className={`badge border ${salary.status === 'Pending' ? 'border-warning text-warning' : salary.status === 'Approved' ? 'border-success text-success' : 'border-light text-light'} status`}>
                                                                                        <i className={`ri-${salary.status === 'Pending' ? 'hourglass-fill' : salary.status === 'Approved' ? 'thumb-up-fill' : 'thumb-down-line'}`}></i> {salary.status}
                                                                                    </span>
                                                                                </td>
                                                                                {/* <td>{salary.comments}</td> */}
                                                                                <td className="text-center">
                                                                                    {salary.status === 'Pending' && (
                                                                                        <>
                                                                                            <span>
                                                                                                <button className="btn btn-link text-info btn-action custom-dropdown-btn dropdown-toggle" type="button" title="Update"
                                                                                                    data-target={`updateRequest${index}`} data-toggle="dropdown" rel="tooltip" onClick={(event) => handleDropdownToggle(event, index)}>
                                                                                                    <i className="ri-list-settings-line"></i>
                                                                                                </button>
                                                                                                <div id={`updateRequest${index}`} className="dropdown-menu dropdown dropdown-menu-right custom-dropdown-advance shadow" ref={dropdownRef}>
                                                                                                    <div className="row">
                                                                                                        <div className="col-12 mb-2 border-bottom">
                                                                                                            <h6>Amount Requested: {salary.amount}</h6>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row drop-down-scroll">
                                                                                                        <div className="col-lg-12 col-md-12">
                                                                                                            <div className="form-group">
                                                                                                                <label htmlFor="costDetails" className="required">Claim Amount</label>
                                                                                                                <div className="input-group">
                                                                                                                    <div className="input-group-prepend" onClick={(e) => e.stopPropagation()}>
                                                                                                                        <Select
                                                                                                                            className="react-select-container"
                                                                                                                            classNamePrefix="react-select"
                                                                                                                            name="currencySymbol"
                                                                                                                            options={options}
                                                                                                                            onChange={handleSelectChange}
                                                                                                                            value={formData.currencySymbol ? { value: formData.currencySymbol, label: formData.currencySymbol } : null}  // Pass value prop
                                                                                                                            placeholder=""
                                                                                                                            components={{ ClearIndicator }}
                                                                                                                            isClearable
                                                                                                                            menuPortalTarget={document.body}
                                                                                                                            styles={{
                                                                                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                                                                control: base => ({ ...base, zIndex: 1 })
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    <input
                                                                                                                        type="number"
                                                                                                                        className="form-control"
                                                                                                                        name="amount"
                                                                                                                        value={formData.amount}
                                                                                                                        onChange={handleInputChange}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="form-group col-12">
                                                                                                            <label htmlFor="notifyDescription">Description</label>
                                                                                                            <textarea
                                                                                                                className="form-control"
                                                                                                                rows="2"
                                                                                                                cols="5"
                                                                                                                name="description"
                                                                                                                value={formData.description}
                                                                                                                onChange={handleInputChange}
                                                                                                            ></textarea>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="row">
                                                                                                        <div className="col-12 text-center">
                                                                                                            <button type="reset" className="btn btn-light" onClick={handleUpdateClear}>Cancel</button>
                                                                                                            <button type="button" className="btn btn-primary" onClick={handleUpdate}>Update <i className="ri-checkbox-circle-line"></i></button>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </span>
                                                                                            <span>
                                                                                                <button className="btn btn-link text-danger btn-action" type="button" title="Cancel" rel="tooltip" onClick={() => handleCancel(index)}>
                                                                                                    <i className="ri-close-circle-line"></i>
                                                                                                </button>
                                                                                            </span>
                                                                                        </>
                                                                                    )}
                                                                                    {salary.status !== 'Pending' && (
                                                                                        <button className="btn btn-link text-info btn-action custom-dropdown-btn" type="button" title="Download" rel="tooltip" onClick={() => handleDownloadPDF(salary)}>
                                                                                            <i className="ri-download-2-line"></i>
                                                                                        </button>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card ww-app-bg">
                                <div className="card-body">
                                    <span><i className="ri-user-2-fill"></i></span>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h4 className="mb-2">Know about your HR?</h4>
                                    <p>Click the below icon and refer all our policies related to your needs.</p>
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-auto text-center">
                                            <Link to={'/policies'} className="info-icon-box" title="Policies" rel="tooltip"><i className="ri-file-text-line"></i></Link>
                                        </div>
                                    </div>

                                    <div className="row align-items-center border-top">
                                        <div className="col-12">
                                            <p className="mt-3">Quickly get in touch us for more queries.</p>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-1"><i className="ri-mail-send-fill"></i></div>
                                        <div className="col">{config?.hrEmail}</div>
                                    </div>
                                    {/* <div className="row mt-2">
                                        <div className="col-1"><i className="ri-phone-fill"></i></div>
                                        <div className="col">+255 12345 67890</div>
                                    </div> */}
                                    <div className="row mt-2">
                                        <div className="col-1"><i className="ri-message-3-line"></i></div>
                                        <div className="col">Chat with us</div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col text-center"><Link to={'/HrConnect'} className="btn btn-secondary mt-lg-0 mt-4" title="Update Information" rel="tooltip"><i className="ri-user-2-fill"></i> Contact Us</Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row fixed-footer">
                <div class="col-lg-12 text-center">
                    <button type="reset" class="btn btn-light" onClick={handleClear}>Clear</button>
                    <button type="submit" class="btn btn-primary" data-toggle="modal" data-target="#cautionModal" onClick={handleSubmit}>Submit <i class="ri-checkbox-circle-line"></i></button>
                </div>
            </div>
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="successModalModalLabel">Success!</h6>
                                <button className="close" type="button" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-12 text-success text-center"><i className="ri-checkbox-circle-fill"></i></div>
                                    <div className="col-12 text-center">Advance Salary Requested successfully.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AdvanceSalary;

